export const projects = [
    {
        name: "Fleeds",
        description: "A full-stack Twitter/X-style web app",
        techStack: [
            "Dart",
            "Flutter",
            "Firebase",
        ],
        images: [
            "fleeds-1",
            "fleeds-2",
            "fleeds-3",
        ],
        repoLink: "https://github.com/marcojalenyu/fleeds",
        projectLink: "https://fleeds.web.app/",
    },
    {
        name: "MyFarm",
        description: "A basic farm simulation game",
        techStack: [
            "Java",
        ],
        images: [
            "myfarm-1",
            "myfarm-2",
            "myfarm-3",
        ],
        repoLink: "https://github.com/marcojalenyu/myfarm",
        projectLink: "",
    },
    {
        name: "Road Width Detection Pipeline",
        description: "Estimates road widths from satellite images",
        techStack: [
            "Python"
        ],
        images: [
            "road-width-1",
            "road-width-2",
            "road-width-3"
        ],
        projectLink: ""
    },
    {
        name: "Classify",
        description: "Uses a distributed system",
        techStack: [
            "C#",
            ".NET",
        ],
        images: [
            "classify-1",
            "classify-2",
            "classify-3"
        ],
        repoLink: "https://github.com/dominicsiaa/classify",
        projectLink: "",
    },
    {
        name: "Taskbound App",
        description: "A gamified reminders app",
        techStack: [
            "Java",
        ],
        images: [
            "taskbound-1",
            "taskbound-2",
            "taskbound-3",
        ],
        repoLink: "https://github.com/marcojalenyu/taskbound",
        projectLink: "",
    },
    {
        name: "AGCWDer",
        description: "",
        techStack: [
            "Python",
            "Flask",
            "OpenCV",
        ],
        images: [
            "agcwder-1",
            "agcwder-2",
        ],
        repoLink: "https://github.com/marcojalenyu/agcwder",
        projectLink: "https://agcwder.onrender.com/",
    },
    {
        name: "Charity Sponsor Record System",
        description: "Worked frontend with Scrum method",
        techStack: [
            "JavaScript",
            "React",
            "Bootstrap",
            "Next.js",
            "MongoDB"
        ],
        images: [
            "psb-1",
            "psb-2",
            "psb-3",
        ],
        repoLink: "https://github.com/KyleCarlo/PearlSBuckPH",
        projectLink: "https://pearlsbuck.vercel.app/",
    },
    {
        name: "Nota",
        description: "A web-based notes-sharing forum",
        techStack: [
            "JavaScript",
            "MongoDB",
            "Express",
            "Node.js"
        ],
        images: [
            "nota-1",
            "nota-2",
            "nota-3",
        ],
        repoLink: "https://github.com/Xiao-Alatus/ccapdev-mc02",
        projectLink: "https://nota-mky9.onrender.com/home",
    },
    {
        name: "Abot - A Well-being Chatbot",
        description: "Published on AsianCHI Symposium 2021",
        techStack: [
            "JavaScript",
            "Dialogflow",
            "Firebase"
        ],
        images: [
            "abot-1",
            "abot-2",
            "abot-3",
        ],
        repoLink: "",
        projectLink: "https://dl.acm.org/doi/10.1145/3429360.3468177",
    }
]